export default {
  init() {
    this.container = document.querySelector('.reports-main__items');
    this.searchForm = document.querySelector('.reports-main__search .search-form');
    this.searchInput = document.querySelector('.reports-main__search .search-form__input');
    this.searchResetButton = document.querySelector('.reports-main__search .search-form__reset');

    this.searchPhrase();
    this.searchReset();
  },

  // listener for search
  searchPhrase() {
    // update url
    this.searchForm.addEventListener('submit', (e) => {
      e.preventDefault();

      let phrase = this.searchInput.value;
      this.updateHistory('?phrase=' + phrase)

      // set params
      const ajaxData = new FormData();
      ajaxData.append('action', 'search_reports');
      ajaxData.append('phrase', phrase);

      // fetch results
      this.fetchResults(ajaxData);
    });
  },

  // update history state
  updateHistory(url) {
    history.pushState({}, 'Found results', url);
  },

  // fetch the results
  fetchResults(data) {
    // fetching...
    fetch(seuk_globals.ajax_url, {
      method: 'POST',
      credentials: 'same-origin',
      body: data,
    })
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      // check if json results are loaded
      this.container.innerHTML = data;
    })
    .catch((error) => {
      console.log(error);
    });
  },

  // listener for search reset
  searchReset() {
    this.searchResetButton.addEventListener('click', () => {
      const url = new URL(window.location.href);
      const params = new URLSearchParams(url.search.slice(1));

      if (params.get('phrase')) {
        // set params
        const ajaxData = new FormData();
        ajaxData.append('action', 'search_reports');
        ajaxData.append('phrase', '');

        // fetch results
        this.fetchResults(ajaxData);

        // remove phrase param from url
        params.delete('phrase');
        window.history.replaceState({},'',`${window.location.pathname}?${params}${window.location.hash}`);
      }
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/postTypeArchiveReports.js